<template>
  <div id="footer-mobile">
      <div class="content-footer-wrapper">
        <s-button
          cluster="k"
          tag="button"
          variant="primary"
          size="small"
          @click="downloadPDF"
          class="w-100 s-mb-3"
        >
          Unduh versi PDF
        </s-button>
        <s-button
          v-if="sertifikatImage && sertifikatImage.length === 1"
          cluster="k"
          tag="button"
          variant="secondary"
          size="small"
          @click="downloadImage"
          class="w-100"
        >
          Unduh versi Gambar
        </s-button>
        <!--
        <div class="share-button" @click="openShareModal">
          <img :src="shareIcon" alt="share-icon">
          <div class="share-text-value">Bagikan Sertifikat</div>
        </div>
        -->
      </div>
      <!-- <share-social :openModal="showShareModal" @closeModal="closeShareModal"></share-social> -->
  </div>
</template>

<script>

import ImageSertifikat from '../../assets/images/sertifikat/index'
// import ShareSocial from './ShareSertifikatModal'

export default {
  name: 'FooterMobile',
  components: {
    // ShareSocial
  },
  data: () => ({
    shareIcon: ImageSertifikat.share,
    showShareModal: false
  }),
  methods: {
    downloadPDF () {
      window.open(this.sertifikatPdf)
    },
    downloadImage () {
      window.open(this.sertifikatImage[0])
    },
    openShareModal () {
      this.showShareModal = true
    },
    closeShareModal () {
      this.showShareModal = false
    }
  },
  computed: {
    sertifikatPdf () {
      return this.$store.state.certificate.currentCertificate.url_pdf
    },
    sertifikatImage () {
      return this.$store.state.certificate.currentCertificate.url_image
    }
  }

}
</script>

<style scoped>
#footer-mobile {
  width: 100%;
  margin-bottom: 70px;
}

.content-footer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.share-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 5px 0px;
}

.share-text-value {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #3498DB;
}
</style>
